import { fork, put, takeLatest } from 'redux-saga/effects';

import { simpleRequest } from 'modules/app/utils';
import { createNotification } from 'modules/toast-notifications/actions';
import auditStatisticsSagas from 'sagas/auditStatisticsSagas';

import * as types from '../actionTypes';

function* handleExportFailure({ payload: error }) {
  if (error?.response?.data.errorCode === 409 &&
    error.response.data.errorType === 'SAME_USER_EXPORT_ALREADY_EXISTS') {
    yield put(createNotification({
      type: 'simple-error',
      message: {
        id: 'statistics_identical.content',
        defaultMessage: 'Your export is being processed. This operation may take up to an hour.'
      },
    }));
  } else {
    yield put(createNotification({
      type: 'error',
      message: {
        id: 'statistics_audit.export_error',
        defaultMessage: 'An error occurred while exporting the data',
      },
    }));
  }
}

export default function* auditModelSagas() {
  yield fork(auditStatisticsSagas);
  yield takeLatest(types.AUDIT_STATISTICS_EXPORT_REQUEST, simpleRequest, {
    notifications: {
      success: {
        id: 'statistics_audit.export_success',
        defaultMessage: 'Export in progress. Please check your inbox in a few minutes.',
      },
    },
  });
  yield takeLatest(types.AUDIT_STATISTICS_EXPORT_FAILURE, handleExportFailure);
}
